// 个人中心
import { userPost } from '../utils/request';

// 获取短信验证码
export function sendSmsCode(data) {
  return userPost('/sendSmsCode', data)
}

// 注销登录
export function logout(data) {
  return userPost('/logout', data)
}

// 获取个人资料
export function getUserinfo(data) {
  return userPost('/getUserinfo', data)
}

// 修改用户头像
export function editUserAvatar(data) {
  return userPost('/editUserAvatar', data)
}

// 修改用户昵称
export function editUserNickname(data) {
  return userPost('/editUserNickname', data)
}

// 修改用户密码
export function editUserPassword(data) {
  return userPost('/editUserPassword', data)
}

// 修改用户绑定手机号
export function editUserPhone(data) {
  return userPost('/editUserPhone', data)
}

// 添加用户采集记录
export function addUserCollections(data) {
  return userPost('/addUserCollections', data)
}

// 用户报价记录列表
export function getUserCollections(data) {
  return userPost('/getUserCollections', data)
}

// 用户作图记录列表
export function getUserDownloads(data) {
  return userPost('/getUserDownloads', data)
}

// 首页用户估价
export function getUserEvaluate(data) {
  return userPost('/getUserEvaluate', data)
}

// 首页用户报价记录列表
export function getUserCollection(data) {
  return userPost('/getUserCollection', data)
}

// 用户关联列表
export function getUserAssociation(data) {
  return userPost('/getUserAssociation', data)
}

// 用户关联列表解绑绑定
export function editUserAssociation(data) {
  return userPost('/editUserAssociation', data)
}

// 用户关联码绑定
export function addUserAssociation(data) {
  return userPost('/addUserAssociation', data)
}

